// Stimulus
import { Application } from '@hotwired/stimulus';
import { registerControllers } from 'stimulus-vite-helpers';

// Turbo
import * as Turbo from '@hotwired/turbo';

// Assets
import '../assets/img/favicon/apple-touch-icon.png';
import '../assets/img/favicon/favicon-32x32.png';
import '../assets/img/favicon/favicon-16x16.png';
import '../assets/img/svg/icon-arrow.svg';
import '../assets/img/svg/icon-next.svg';
import '../assets/img/svg/icon-sound.svg';
import '../assets/img/svg/icon-fontsize.svg';
import '../assets/img/svg/icon-dyslexia.svg';
import '../assets/img/svg/icon-play.svg';
import '../assets/img/svg/icon-plus.svg';
import '../assets/img/svg/icon-close.svg';
import '../assets/img/svg/icon-check-round.svg';
import '../assets/img/svg/select-icon.svg';
import '../assets/img/svg/mask-bl.svg';
import '../assets/img/svg/mask-tl.svg';
import '../assets/img/svg/mask-br.svg';
import '../assets/img/svg/mask-tr.svg';
import '../assets/img/logo/logo.jpg';

// Start Stimulus
const application = Application.start();
const controllers = import.meta.glob('./**/*_controller.js', { eager: true });
registerControllers(application, controllers);

// Start Turbo
Turbo.start();

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log('HMR'); // eslint-disable-line no-console
  });
}
